import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts(
  'profile',
  'insurance-eligibility-manual-activations',
);

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'insurance_eligibility',
  type: 'post',
  slug: [
    'results',
    {
      type: 'payload',
      selector: ['insuranceEligibilityResultId'],
    },
    'manual_activations',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/profiles/insurance-eligibility-manual-activations.js